module.exports = __webpack_public_path__ + "static/portfolio_particles-cee65311357aea77ebed41f04ab01548.png";